import React, { useEffect } from "react";
import { IonLabel, IonImg } from "@ionic/react";
import { ITrailerOutProps } from "../../../schemas/StartTrip/StartTrip";
import { StartTripModel } from "../../../models/home/StartTrip.model";
import { ComboBox } from "./trailerComboBox";
import { useTranslation } from "react-i18next";
import { chassisNumberFinder } from "../../../web/components/execution/executionUtils";

export const TrailerOut: React.FunctionComponent<ITrailerOutProps> = (
  props: ITrailerOutProps
) => {
  const model: StartTripModel = new StartTripModel();
  const trailerOut = model.getTrailerOut(
    props.loadStop,
    props.shipment
  );
  const { t } = useTranslation();

  useEffect(() => {
    props.onChange(trailerOut.trailerOut);
    if (trailerOut?.activity) {
      props.changeActivity(trailerOut.activity);
    }
  }, [JSON.stringify(trailerOut), props.shipmentId, props.timestamp]);
  const drayLoad_Out_Label = () => props.shipment?.isDrayRoute ? t('Container Out') : t('Trailer Out');
  return (
    <>
   { props.mobile 
       ?  <div data-testid="trailer-selection" className="dropdown-button" onClick={() => props.handleShowDropDown(!props.showDropDown)}>
           <IonLabel className="ETA-label">{drayLoad_Out_Label()}</IonLabel>
           <i className="down"></i>
         </div>
    : <IonLabel className="ETA-label">{drayLoad_Out_Label()}</IonLabel>
    } 

      <ComboBox
        mobile={props.mobile}
        web={props.web}
        value={props.value}
        onChange={(value: string) => props.onChange(value)}
        showError={props.showError}
        disabled={props.readonly || props.isNextStop}
        onFocus={(obj:any) => {
          props.expandCurrentStopForcefully(obj);
          return false;
        }}
        showOptions={props.showDropDown}
        showDropDown={(value:boolean) => props.handleShowDropDown(value)}
        dropdownType = "trailerOut"
        stopType = {props.loadStop?.stopType}
        sequenceNo = {props.loadStop?.sequenceNo}
        isDray = {props.shipment?.isDrayRoute}
        chasisNumber = {chassisNumberFinder(props.loadStop?.stopActivity,"TRAILER_OUT")}
      />
      {props.web && 
      <IonImg
       className="form-field-icon trailer-icon"
       src="assets/icon/down arrow@2x.png"
       data-testid="trailer-selection-web"
       onClick={() => props.handleShowDropDown(!props.showDropDown)}
      />
      }
    </>
  );
};
